export default __webpack_public_path__ + "static/media/lds-logo_th.d9efddebbfc27b3e.svg";